<template>
  <b-container>
    <!-- Board Container -->
    <div id="container">
      <div
        id="result"
        :style="{ display: showWinLine }"
        @click="gameStarted = false"
      >
        <p v-if="winner == 'x'">X Wins!</p>
        <p v-else-if="winner == 'o'">O Wins!</p>
        <p v-else>Tie</p>
      </div>
      <!-- Win Line -->
      <div
        id="winline"
        :style="{ display: showWinLine }"
        @click="gameStarted = false"
      >
        <svg width="450" height="450" viewBox="0 0 450 450">
          <line
            fill="none"
            stroke="#c95f0a"
            stroke-width="10"
            :x1="winLine[0]"
            :y1="winLine[1]"
            :x2="winLine[2]"
            :y2="winLine[3]"
          />
        </svg>
      </div>
      <!-- Board -->
      <section id="board">
        <!-- Square 1 -->
        <div class="square" @click="makeMove(1)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[0] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[0] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 2 -->
        <div class="square" @click="makeMove(2)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[1] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[1] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 3 -->
        <div class="square" @click="makeMove(3)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[2] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[2] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 4 -->
        <div class="square" @click="makeMove(4)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[3] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[3] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 5 -->
        <div class="square" @click="makeMove(5)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[4] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[4] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 6 -->
        <div class="square" @click="makeMove(6)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[5] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[5] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 7 -->
        <div class="square" @click="makeMove(7)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[6] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[6] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 8 -->
        <div class="square" @click="makeMove(8)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[7] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[7] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
        <!-- Square 9 -->
        <div class="square" @click="makeMove(9)">
          <!-- O -->
          <svg
            class="o"
            :style="{ display: showO[8] }"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <circle
              fill="none"
              stroke="#fff"
              stroke-width="9"
              cx="75"
              cy="75"
              r="40"
            />
          </svg>
          <!-- X -->
          <svg
            :style="{ display: showX[8] }"
            class="x"
            width="146px"
            height="146px"
            viewBox="0 0 146 146"
          >
            <line
              class="lin1"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="40"
              y1="40"
              x2="110"
              y2="110"
            />
            <line
              class="lin2"
              fill="none"
              stroke="#fff"
              stroke-width="9"
              x1="110"
              y1="40"
              x2="40"
              y2="110"
            />
          </svg>
        </div>
      </section>
    </div>
    <!-- Settings -->
    <section id="settings">
      <div>
        <!-- Start -->
        <div id="start">
          <a class="btn" @click="startGame">Restart</a>
        </div>
        <!-- Settings: # Players -->
        <div>
          <h3>Players</h3>
          <div id="players">
            <a
              class="btn"
              :class="{ active: players == '1' }"
              @click="players = '1'"
              >1</a
            >
            <a
              class="btn"
              :class="{ active: players == '2' }"
              @click="players = '2'"
              >2</a
            >
          </div>
        </div>
        <!-- Settings: Player 1 (X or O) -->
        <div>
          <h3>Player 1</h3>
          <div id="players">
            <a class="btn" :class="{ active: p1 == 'x' }" @click="p1 = 'x'"
              >X</a
            >
            <a class="btn" :class="{ active: p1 == 'o' }" @click="p1 = 'o'"
              >O</a
            >
          </div>
        </div>
      </div>
    </section>
  </b-container>
</template>

<script>
import _ from "lodash";
import Vue from "vue";

export default {
  name: "Display_TicTacToe",
  components: {},
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.memoryCards = _.shuffle(
      this.memoryCards.concat(_.cloneDeep(this.cards), _.cloneDeep(this.cards))
    );
    this.reset(true);
  },
  data() {
    return {
      state: ["", "", "", "", "", "", "", "", ""],
      showO: [
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      showX: [
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      turn: "x", // Whose turn is it?  (X or O)
      p1: "x", // Is player 1 X or O?
      turnCount: 0, // What turn is it?
      players: "1", // How many players?
      showWinLine: "none", // Show the winning line?
      gameOver: false, // Is the game over?
      gameStarted: false, // Has the game started?  (Board shown if true)
      computerMoving: false, // Is the computer making a move?
      winner: "", // Who won?
      winLine: [0, 0, 0, 0], // What was the winning line?
      winningSequences: [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6]
      ]
    };
  },
  computed: {},
  methods: {
    handleAppLog(data) {
      //Move to Mixin
      this.$emit("appLog", data);
    },
    startGame() {
      this.restart();
      this.turn = this.p1;
      this.gameStarted = true;

      this.handleAppLog({
        name: "display.startGame",
        payload: { turn: this.turn, gameStarted: this.gameStarted },
        level: "info"
      });
    },
    makeMove(square) {
      if (!this.computerMoving) this.setSquare(square);

      this.handleAppLog({
        name: "display.makeMove",
        payload: { turn: this.turn, gameStarted: this.gameStarted },
        level: "info"
      });
    },
    setSquare(square) {
      if (this.gameOver) {
        this.gameStarted = false;
        return;
      }
      // If the square has not been set
      if (!this.state[square - 1]) {
        // Set the square
        Vue.set(this.state, square - 1, this.turn);
        if (this.turn == "o") Vue.set(this.showO, square - 1, "block");
        else Vue.set(this.showX, square - 1, "block");
        this.turnCount++;
        this.checkForWinner();
        if (this.turnCount != 9) this.toggleTurn();
        else if (this.turnCount == 9 && !this.winner) {
          this.gameOver = true;
          this.showWinLine = "inline";
        }
        if (
          this.players == "1" &&
          this.turn != this.p1 &&
          !this.gameOver &&
          !this.computerMoving
        ) {
          this.computerMoving = true;
          setTimeout(this.computerMove, 500);
        }
      }

      this.handleAppLog({
        name: "display.setSquare",
        payload: { square: square },
        level: "info"
      });
    },
    computerMove() {
      // Find an empty square and set it
      let madeMove = false;
      while (madeMove == false) {
        let x = Math.floor(Math.random() * 9);
        if (this.state[x] == "") {
          this.setSquare(x + 1);
          madeMove = true;
          let self = this;
          setTimeout(function() {
            self.computerMoving = false;
          }, 500);
        }
      }
      this.handleAppLog({
        name: "display.computerMove",
        payload: {},
        level: "info"
      });
    },
    toggleTurn() {
      if (this.turn == "o") this.turn = "x";
      else this.turn = "o";

      this.handleAppLog({
        name: "setting.toggleTurn",
        payload: {},
        level: "info"
      });
    },
    checkForWinner() {
      let self = this;
      this.winningSequences.forEach(function(sequence, index) {
        if (self.state[sequence[0]] != "")
          if (
            self.state[sequence[0]] == self.state[sequence[1]] &&
            self.state[sequence[1]] == self.state[sequence[2]]
          ) {
            switch (index) {
              case 0:
                self.winLine = [20, 77, 430, 77];
                break;
              case 1:
                self.winLine = [20, 227, 430, 227];
                break;
              case 2:
                self.winLine = [20, 377, 430, 377];
                break;
              case 3:
                self.winLine = [77, 20, 77, 430];
                break;
              case 4:
                self.winLine = [227, 20, 227, 430];
                break;
              case 5:
                self.winLine = [379, 20, 379, 430];
                break;
              case 6:
                self.winLine = [20, 20, 430, 430];
                break;
              case 7:
                self.winLine = [435, 20, 20, 435];
                break;
            }
            self.gameOver = true;
            self.showWinLine = "inline";
            self.winner = self.state[sequence[0]];
          }
      });

      this.handleAppLog({
        name: "setting.checkForWinner",
        payload: {},
        level: "info"
      });
    },
    restart() {
      this.gameOver = false;
      this.showWinLine = "none";
      this.turnCount = 0;
      this.winner = "";
      this.state = ["", "", "", "", "", "", "", "", ""];
      this.turn = "x";
      this.winLine = [0, 0, 0, 0];
      this.showO = [
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ];
      this.showX = [
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ];

      this.handleAppLog({
        name: "setting.restart",
        payload: {},
        level: "info"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$color-white: #ffffff;
$color-blue: #0071bc;
$color-dark-blue: #033e67;
$color-light-blue: #1aa3ff;
$color-orange: #c95f0a;
$color-dark-orange: #703200;
$color-light-orange: #ff8726;

svg {
  display: block;
}
h1,
h2,
h3 {
  margin: 0;
  text-align: center;
}

#app {
  max-width: 500px;
  color: $color-white;
  background-color: $color-blue;
  margin: 2rem auto 0 auto;
  box-shadow: 2px 2px 18px rgba(0, 0, 0, 0.3);
  padding-bottom: 0.5rem;
}
h1 {
  padding: 1.5rem;
  font-size: 1.5rem;
  background-color: $color-dark-blue;
}
h2 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
h3 {
  font-weight: normal;
  margin-bottom: 0.5rem;
}

#settings {
  //background-color: $color-light-blue;
  padding: 1rem;
}
#settings > div {
  display: flex;
  justify-content: space-around;
}
#players {
  display: flex;
}
#start {
  margin-top: 2rem;
  .btn {
    padding: 1rem 6rem;
    background-color: $color-orange;
  }
}
.btn {
  font-weight: bold;
  background-color: $color-dark-orange;
  padding: 1rem 1.5rem;
  cursor: pointer;
  user-select: none;
}
.btn:hover {
  background-color: $color-light-orange;
}
.btn.active {
  background-color: $color-orange;
}

// Container to Tic Tac Toe Board
#container {
  position: relative;
  width: 450px;
  height: 450px;
  margin: 1rem auto;
}
#result {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  text-align: center;
  p {
    font-size: 3rem;
    color: $color-white;
    display: inline;
    padding: 1rem;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    background-color: rgba(0, 0, 0, 0.8);
  }
}
// Win Line
#winline {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99;
  svg line {
    stroke-dasharray: 800;
    stroke-dashoffset: 800;
    animation: dash 0.4s linear forwards;
    animation-delay: 0.4s;
  }
}
// Board
#board {
  background-color: $color-blue;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 450px;
  min-width: 450px;
}
.square {
  text-align: center;
  min-width: 146px;
  min-height: 146px;
  border-right: 6px solid $color-white;
  border-bottom: 6px solid $color-white;
  &:nth-of-type(3n) {
    border-right: none;
  }
  &:nth-of-type(7),
  &:nth-of-type(8),
  &:nth-of-type(9) {
    border-bottom: none;
  }
}

.o {
  vertical-align: middle;
  stroke-dasharray: 251.327;
  stroke-dashoffset: 251.327;
  animation: dash 0.4s linear forwards;
}
.x {
  stroke-dasharray: 99;
  stroke-dashoffset: 99;
  .lin1 {
    animation: dash 0.2s linear forwards;
  }
  .lin2 {
    animation: dash 0.2s linear forwards;
    animation-delay: 0.2s;
  }
}
@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
